export enum BlockCompositionType {
  BLOCK = 'BLOCK',
  CONTAINER = 'CONTAINER',
  STRUCTURE = 'STRUCTURE',
  STRIPE = 'STRIPE',
}
